// 泰语

export default {
  t1: 'เสร็จสิ้น',
  t5: 'ชำระเงิน',
  t6: 'การผูกและอนุญาต',
}
